{
  "name": "@homer.core/page",
  "version": "1.45.1",
  "type": "module",
  "private": false,
  "config": {},
  "main": "./dist/index.js",
  "module": "./src/index.js",
  "exports": {
    ".": "./src/index.js",
    "./package.json": "./package.json"
  },
  "scripts": {},
  "dependencies": {
    "@homer.api/fragment": "*",
    "@homer.core/api": "*",
    "@homer.core/application": "*",
    "@homer.core/emitter": "*",
    "@homer.core/queue.raf": "*",
    "@homer.core/scheduler": "*",
    "@homer.core/types": "*",
    "@homer.utility/foreach": "*",
    "@homer.utility/uuid": "*",
    "@homer.utility/validator.isinstanceof": "*",
    "@homer.utility/validator.isundefined": "*",
    "@shared/reset": "*"
  },
  "devDependencies": {},
  "requires": [],
  "loads": []
}
